var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-empty-state',_vm._b({},'gl-empty-state',Object.assign({}, _vm.$options.emptyStatePropsMap[_vm.errorCode], {svgPath: _vm.illustrations[_vm.errorCode]}),false))}
var staticRenderFns = []

export { render, staticRenderFns }